import { Injectable } from '@angular/core';

@Injectable()
export class RestrictOutsideScrollService {
	scrollY = window.scrollY;

	hideBackgroundScroll(makeBodyFixed?: boolean) {
		document.querySelector('body').classList.add('body-overflow-hidden');
		if (makeBodyFixed) {
			this.lockBodyScroll();
		}
	}

	showBackgroundScroll(isBodyFixed?: boolean) {
		if (document.querySelector('body').classList.contains('body-overflow-hidden')) {
			document.querySelector('body').classList.remove('body-overflow-hidden');
		}
		if (isBodyFixed) {
			this.unlockBodyScroll();
		}
	}

	lockBodyScroll() {
		document.body.style.position = 'fixed';
		document.body.style.top = `-${scrollY}px`;
		document.body.style.width = '100%';
	}

	unlockBodyScroll() {
		document.body.style.position = '';
		document.body.style.top = '';
		document.body.style.width = '';
		window.scrollTo(0, scrollY);
	}
}